<template>
  <!--搜索 开始-->
  <div class="search-box">
    <div class="list-search list-search-placeholder" :style="hotelRoomSearchFixedPlaceholder"></div>
    <div class="list-search" :style="hotelRoomSearchFixed">
      <!--位置搜索 开始-->
      <div>
        <div class="location-search-pc">
          <div class="hotellist-region el-input el-input--large el-input--suffix" :style="{'width': `${regionSearchWidth}px`}">
            <el-autocomplete popper-class="my-autocomplete" class="inline-input" :style="{'min-width': `${regionSearchWidth}px`}" v-model="state" :fetch-suggestions="querySearch" :placeholder="$t('goingTo')" @select="handleSelect"  @input="loadAll" :popper-append-to-body="false" placement="bottom-start">
              <template slot-scope="{ item }">
                <div style="width:48px;float: left;text-align:center;" >
                  <div v-if="item.type == 'location'" class="locationClass"></div>
                  <div v-if="item.type == 'hotel'" class="hotelClass"></div>
                </div>
                <div style="width:82%;float:left;display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left;text-indent: 0.3rem;">
                  <div class="name">
                    <span v-html="getLanguageHtml(item, 'value')"></span>
                  </div>
                  <span class="addr" style="display: block;line-height: 25px;">
                  <span v-html="getLanguageHtml(item, 'address')"></span>
                </span>
                </div>
              </template>
            </el-autocomplete>
          </div>
          <div class="hotellist-date-all" @click="dateSearchShow()" data-index="date-pc">
            <div class="el-date-editor el-range-editor el-input__inner hotellist-date el-date-editor--daterange" style="padding:0px;" :class="{'hotellist-date-show':hotelDateSearchShow}" data-index="date-pc">
              <i class="el-input__icon el-range__icon input-date-icon" style="background-position: center center;padding: 0px 10px;" data-index="date-pc"></i>
              <div class="hotellist-date-start" :class="{'hotellist-date-start-left': language === 'en'}" data-index="date-pc">
                <div class="hotellist-date-start-date" data-index="date-pc">{{checkDateWeek.date[0]}}</div>
                <div class="hotellist-date-start-week" data-index="date-pc">{{checkDateWeek.week[0]}}</div>
              </div>
              <div class="hotellist-date-line" data-index="date-pc"><img src="/static/img/home/date-line-bold.png" alt="" data-index="date-pc"></div>
              <div class="hotellist-date-end" data-index="date-pc">
                <div class="hotellist-date-end-date" data-index="date-pc">{{checkDateWeek.date[1]}}</div>
                <div class="hotellist-date-end-week" data-index="date-pc">{{checkDateWeek.week[1]}}</div>
              </div>
            </div>
            <div>
              <el-date-picker v-model="input_date" type="daterange" prefix-icon="input-date-icon" :start-placeholder="$t('startIn')" :end-placeholder="$t('endOut')" format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="hotellist-date-hidden" popper-class="hotellist-date-time-show hotelRoomSearchFixedDate" :clearable="dateClearable" ref="saveDateInput" :append-to-body="false"  @change="selectTime" :picker-options="pickerOptions" style="position: absolute;height: 0px;bottom: 5px;background: rgb(0,0,0,0); border: 0px;" data-index="date-pc"></el-date-picker>
            </div>
          </div>

          <div class="select-person">
            <div class="hotellist-person el-select--large" @click="showPerson($event)" data-index="person-pc">
              <div class="el-input el-input--large el-input--suffix" data-index="person-pc">
                <div class="person-inner" :class="{'showPersonBorder':showPersonInfo}" data-index="person-pc">
                <span class="personText" data-index="person-pc">
                  <span data-index="person-pc">
                    {{personInfo}}
                    <span v-if="personInfo<=1" data-index="person-pc">{{$t('adult')}}</span>
                    <span v-else data-index="person-pc">{{$t('adults')}}</span>
                  </span>
                  <span v-if="childNum > 0" data-index="person-pc">
                    , {{childNum}}
                    <span v-if="childNum<=1" data-index="person-pc">{{$t('child')}}</span>
                    <span v-else data-index="person-pc">{{$t('children')}}</span>
                  </span>
                </span>
                  <span class="roomText" data-index="person-pc">
                  {{roomInfo}}
                  <span v-if="roomInfo<=1" data-index="person-pc">{{$t('room')}}</span>
                  <span v-else data-index="person-pc">{{$t('rooms')}}</span>
                </span>

                  <div class="el-input__suffix" data-index="person-pc">
                    <div class="el-input__suffix-inner" data-index="person-pc"  style="height: 100%;line-height: 50px;">
                      <i class="el-select__caret el-input__icon el-icon-arrow-down" style="vertical-align: super;" data-index="person-pc"></i>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="personInfo" v-show="showPersonInfo" data-index="person-pc">
              <div class="personnum" data-index="person-pc">
                <button class="personLessno" :class="{'personLess': roomLessDo}" @click="roomLess" data-index="person-pc"></button>
                <span data-index="person-pc">
                  <span class="personSpan main-color" data-index="person-pc">{{roomNum}}</span>
                  <span class="spantext" data-index="person-pc">
                    <span v-if="roomNum<=1" data-index="person-pc">{{$t('room')}}</span>
                    <span v-else data-index="person-pc">{{$t('rooms')}}</span>
                  </span>
                </span>
                <button class="personAdd" @click="roomAdd" :class="{'personAddno':roomAddNoDo}" data-index="person-pc"></button>
              </div>
              <div class="personnum" data-index="person-pc">
                <button class="personLessno" :class="{'personLess': adultLessDo}" @click="adultLess" data-index="person-pc"></button>
                <span data-index="person-pc">
                <span class="personSpan main-color" data-index="person-pc">{{adultNum}}</span>
                <span class="spantext" data-index="person-pc">
                  <span v-if="adultNum<=1" data-index="person-pc">{{$t('adult')}}</span>
                  <span v-else data-index="person-pc">{{$t('adults')}}</span>
                </span>
              </span>
                <span class="personAdd" @click="adultAdd" data-index="person-pc"></span>
              </div>
              <div class="personnum" data-index="person-pc">
                <button class="personLessno" :class="{'personLess': childLessDo}" @click="childLess" data-index="person-pc"></button>
                <span data-index="person-pc">
                <span class="personSpan main-color" data-index="person-pc">{{childNum}}</span>
                <span class="spantext" data-index="person-pc">
                  <span v-if="childNum<=1" data-index="person-pc">{{$t('child')}}</span>
                  <span v-else data-index="person-pc">{{$t('children')}}</span>
                </span>
              </span>
                <span class="personAdd" @click="childAdd" :class="{'personAddno':childAddNoDo}" data-index="person-pc"></span>
              </div>
              <div class="childinfo" style="width:100%;" v-show="showChildInfo" data-index="person-pc">
                <div style="text-align:center" v-html="$t('childAge')" v-if="childNum<=1" data-index="person-pc"></div>
                <div style="text-align:center" v-html="$t('childrenAges')" v-else data-index="person-pc"></div>
                <div v-if="childNum>=1" v-for="(n, nums) in childNum" :key="nums" data-index="person-pc">
                  <div v-if="selecteds[nums] === undefined">
                    <el-select class="selectOld" value="<1" placeholder="-" data-index="person-pc" @change="updateChildSelect(nums, $event)">
                      <el-option v-for="(value, key) in childOld" :key="key" :label="value" :value="value" data-index="person-pc" style="text-align:center"></el-option>
                    </el-select>
                  </div>
                  <div v-else>
                    <el-select class="selectOld" v-model="selecteds[nums]" placeholder="-" data-index="person-pc">
                      <el-option v-for="(value, key) in childOld" :key="key" :label="value" :value="value" data-index="person-pc" style="text-align:center"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nationality-pc">
            <el-select v-model="nationality" filterable placeholder="Nationality (optional)" class="nationality-select" no-match-text="no data">
              <el-option v-for="(item, code) in nationalityAll" :key="code" :label="item" :value="code" style="height: 48px; line-height: 48px;"></el-option>
            </el-select>
          </div>
          <button type="button" v-if="allPermissions.search === 0" class="hotellist_button display_button" style="cursor: not-allowed;">{{$t('search')}}</button>
          <!-- <button type="button" v-else :class="['hotellist_button', agreementChecked.length === 1 ? 'booknow_button' : 'display_button']" :style="{cursor: agreementChecked.length === 1 ? 'pointer' : 'not-allowed'}" @click="searchList" :disabled="agreementChecked.length !== 1">{{$t('search')}}</button> -->
          <button type="button" v-else :class="['hotellist_button', 'booknow_button']" :style="{cursor: 'pointer'}" @click="searchList">{{$t('search')}}</button>
          <div>
            <el-checkbox v-model="agreementChecked"  label="package_agreement" style="margin-top: 10px;" @change="searchAgreementChange">
              <span class="checkbox-label-container">
                <div v-html="$t('agreement')"></div>
                <el-tooltip
                  content="I understand and accept that package rates can only be booked in combination with a flight, car, train or cruise booking for the same traveller and trip."
                  placement="top-start"
                  effect="light"
                  >
                  <span style="cursor: pointer;margin-left: 6px;"><img style="height:15px;width: 15px; display: block;" src="/static/img/searchDetail.png" /></span>
                </el-tooltip>
              </span>
            </el-checkbox>
          </div>
        </div>
      </div>
      <!-- <div style="height:15px;width:100%;background-color: #f2f2f2;"></div> -->
      <!--位置搜索 结束-->
    </div>
  </div>
  <!--搜索 结束-->
</template>

<script>
import { getTimeZone, getCountry } from '@/request/hotel.js'
import { getHotelList } from '@/request/search.js'
import HotelSearch from '@/components/hotelsearch/HotelSearch'
const childSelected = {'0': 'selectedone'}
export default {
  name: 'publicSearchPc',
  props: ['hotelid', 'hotelRoomSearchFixed', 'hotelRoomSearchFixedPlaceholder', 'regionSelData', 'hotelFirstData', 'personWidth', 'allPermissions'],
  components: {
    HotelSearch
  },
  data () {
    return {
      state: this.common.defaultRegion,
      restaurants: {},
      checkDateWeek: {'date': ['', ''], 'week': ['', '']},
      regions: {},
      region_select: this.common.defaultRegionId,
      region_type: this.common.defaultRegionType,
      start_date: '',
      end_date: '',
      input_region: '',
      input_date: '',
      input_person: '',
      roomNum: 1,
      adultNum: 2,
      childNum: 0,
      personInfo: '2',
      adultInfo: '2',
      roomInfo: '1',
      childInfo: '',
      num: 1,
      showPersonInfo: false,
      roomLessDo: false,
      roomAddNoDo: false,
      adultLessDo: true,
      childLessDo: false,
      childAddNoDo: false,
      showChildInfo: false,
      childOld: this.common.childOld,
      childSelected: childSelected,
      selecteds: [],
      allPersonNum: 2,
      hotelSearchFrame: false,
      search_date: '',
      mobile_start_date: '',
      mobile_end_date: '',
      dateClearable: false,
      pickerOptions: '',
      language: this.common.languageSet(this),
      triggerOnFocus: true,
      monthEnglish: {'1': 'Jan', '2': 'Feb', '3': 'Mar', '4': 'Apr', '5': 'May', '6': 'Jun', '7': 'Jul', '8': 'Aug', '9': 'Spt', '10': 'Oct', '11': 'Nov', '12': 'Dec'},
      hotelDateSearchShow: false,
      hotelRoomSearchFixedDate: 'hotellist-date-time-show',
      addrDateTime: '',
      regionSearchWidth: '',
      regionDownSearchWidth: '',
      screenWidth: null,
      nationalityAll: {},
      nationality: '',
      agreementChecked: false
    }
  },
  created () {
    // 下拉
    if (localStorage.getItem('restaurants') !== undefined) {
      var restaurantsJson = localStorage.getItem('restaurants')
      var restaurantsArr = JSON.parse(restaurantsJson)
      this.restaurants = restaurantsArr
    }
    if (this.state === '' || this.state === undefined || this.state === null) {
      this.state = this.common.defaultRegion
      this.region_select = this.common.defaultRegionId
      this.region_type = this.common.defaultRegionType
    }
    this.loadAll(this.state, 1)
    this.defaultDate()
    this.getNationalityAll()

    // 语言
    var that = this
    setInterval(function () {
      that.language = that.common.languageSet(that)
    }, 200)

    // 获取当前日期
    let d = new Date()
    var year = d.getFullYear()
    var month = d.getMonth()
    var tian = d.getDate()
    var monthSelect = (month + 1) < 10 ? '0' + (month + 1).toString() : (month + 1).toString()

    // 默认日期禁止
    var time = year + '-' + monthSelect + '-' + (parseInt(tian)) + ' 00:00:00'
    this.pickerOptions = {
      disabledDate (date) {
        return date.getTime() < new Date(time).getTime()
      }
    }

    var searchAgreementChange = sessionStorage.getItem('searchAgreementChange')
    if (searchAgreementChange !== undefined && (searchAgreementChange === 1 || searchAgreementChange === '1')) {
      this.agreementChecked = true
    } else {
      this.agreementChecked = false
    }
  },
  computed: {
    headerChange: function () {
      return this.hotelRoomSearchFixed
    }
  },
  watch: {
    regionSelData: function (news) {
      if (news !== null) {
        this.state = news.value_en
      }
    },
    hotelFirstData: function (news) {
      // 如果是平台直接跳转到列表页没有带酒店名称 需要查询出且展示
      if (this.$route.query.type === '3' && this.$route.query.region === undefined && JSON.stringify(news) !== '') {
        var regionSel = {'value_zh': news.hotelname_zh, 'value_en': news.hotelname, 'type_id': 3, 'type_data_id': news.hotelid}
        sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

        this.state = regionSel.value_en
        this.$forceUpdate()
      }
    },
    headerChange: function (n, o) {
      if (n !== '') {
        this.hotelRoomSearchFixedDate = 'hotellist-date-time-top-show'
      } else {
        this.hotelRoomSearchFixedDate = 'hotellist-date-time-show'
      }

      this.common.removeClass(document.querySelector('.hotelRoomSearchFixedDate'), 'hotellist-date-time-top-show')
      this.common.removeClass(document.querySelector('.hotelRoomSearchFixedDate'), 'hotellist-date-time-show')
      this.common.addClass(document.querySelector('.hotelRoomSearchFixedDate'), this.hotelRoomSearchFixedDate)
    },
    input_date: function (n, o) {
      if (n[0] === undefined) {
        return false
      }
      this.checkDateWeek = {}
      let startDate = new Date(n[0].replace(/-/g, '/'))
      let startY = startDate.getFullYear()
      let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)
      let startMen = startDate.getMonth()
      let startD = (startDate.getDate() < 10) ? '0' + startDate.getDate() : startDate.getDate()
      let startW = startDate.getDay()

      let endDate = new Date(n[1].replace(/-/g, '/'))
      // 如果开始日期和结束日期选择了同一天，则结束日期=开始日期+1天.
      if (n[0] === n[1]) {
        var endDateStr = startDate.getDate() + 1

        var newStartM = Number(startM) + 1
        var newStartY = startY
        if (newStartM > 12) {
          newStartM = 1
          newStartY = Number(startY) + 1
        }

        var nextMonthFirstDay = new Date(newStartY, Number(newStartM) - 1, 1)
        var lastDayOfMonth = new Date(nextMonthFirstDay - 1)
        var endMaxDate = lastDayOfMonth.getDate()

        if (endDateStr <= endMaxDate) {
          endDate.setDate(endDateStr)
        } else {
          endDate = new Date(newStartY, Number(newStartM) - 1, 1)
        }
      }
      let endY = endDate.getFullYear()
      let endM = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
      let endMen = endDate.getMonth()
      let endD = (endDate.getDate() < 10) ? '0' + endDate.getDate() : endDate.getDate()
      let endW = endDate.getDay()

      // 显示
      if (this.input_date['1'] !== undefined) {
        this.input_date['1'] = endY + '-' + endM + '-' + endD
      }
      var startYmd = ''
      var endYmd = ''
      var startwkstr = ''
      var endwkstr = ''
      if (this.common.languageSet() === 'en') {
        // Sep 15, 2022
        startYmd = this.common.monthEn[startMen] + ' ' + startD + ', ' + startY
        endYmd = this.common.monthEn[endMen] + ' ' + endD + ', ' + endY
        startwkstr = this.common.weekPcEn[startW]
        endwkstr = this.common.weekPcEn[endW]

        this.search_date = startD + ' ' + this.common.monthEn[startMen] + ' - ' + endD + ' ' + this.common.monthEn[endMen]
      } else {
        startYmd = startY + '年' + startM + '月' + startD + '日'
        endYmd = endY + '年' + endM + '月' + endD + '日'
        startwkstr = this.common.weekZh[startW]
        endwkstr = this.common.weekZh[endW]

        this.search_date = startM + '月' + startD + '日 - ' + endM + '月' + endD + '日'
      }

      localStorage.setItem('searchdate', this.search_date)

      this.checkDateWeek.date = []
      this.checkDateWeek.date.push(startYmd)
      this.checkDateWeek.date.push(endYmd)

      this.checkDateWeek.week = []
      this.checkDateWeek.week.push(startwkstr)
      this.checkDateWeek.week.push(endwkstr)

      this.hotelDateSearchShow = false
    },
    language: function (n, o) {
      this.checkDateWeek = {}

      let startDate = new Date(this.input_date[0])
      let startY = startDate.getFullYear()
      let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)
      let startMen = startDate.getMonth()
      let startD = (startDate.getDate() < 10) ? '0' + startDate.getDate() : startDate.getDate()
      let startW = startDate.getDay()

      let endDate = new Date(this.input_date[1])
      let endY = endDate.getFullYear()
      let endM = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
      let endMen = endDate.getMonth()
      let endD = (endDate.getDate() < 10) ? '0' + endDate.getDate() : endDate.getDate()
      let endW = endDate.getDay()

      var startYmd = ''
      var endYmd = ''
      var startwkstr = ''
      var endwkstr = ''
      if (n === 'en') {
        // Sep 15, 2022
        startYmd = this.common.monthEn[startMen] + ' ' + startD + ', ' + startY
        endYmd = this.common.monthEn[endMen] + ' ' + endD + ', ' + endY
        startwkstr = this.common.weekEn[startW]
        endwkstr = this.common.weekEn[endW]
      } else {
        startYmd = startY + '年' + startM + '月' + startD + '日'
        endYmd = endY + '年' + endM + '月' + endD + '日'
        startwkstr = this.common.weekZh[startW]
        endwkstr = this.common.weekZh[endW]
      }

      this.checkDateWeek.date = []
      this.checkDateWeek.date.push(startYmd)
      this.checkDateWeek.date.push(endYmd)

      this.checkDateWeek.week = []
      this.checkDateWeek.week.push(startwkstr)
      this.checkDateWeek.week.push(endwkstr)

      // 目的地 中英文切换
      this.regionSelShow()
    },
    search_date: function (n, o) {
    },
    addrDateTime: function (newTime, oldTime) {
      var addrTime = newTime + ' 00:00:00'
      this.pickerOptions = {
        disabledDate (date) {
          return date.getTime() < new Date(addrTime).getTime()
        }
      }

      const newdate = new Date(newTime)
      newdate.setDate(newdate.getDate() + 1)
      const newDateStr = newdate.toISOString().split('T')[0]

      this.input_date = []
      this.input_date.push(newTime)
      this.input_date.push(newDateStr)

      this.start_date = newTime
      this.end_date = newDateStr
      var query = {'region': this.state, 'type_id': this.region_select, 'type': this.region_type, 'start_date': newTime, 'end_date': newDateStr, 'room': this.roomNum, 'adult': this.adultNum, 'child': this.childNum, 'allPersonNum': this.allPersonNum, 'childNums': this.selecteds}
      this.$router.push({path: '/portal/booking/hotelsearch/HotelList', query: query})
    },
    screenWidth: {
      handler: function (val) {
        this.regionSearchWidth = this.screenWidth - 1050
        this.regionDownSearchWidth = this.regionSearchWidth
        if (this.screenWidth <= 1600 && this.screenWidth > 1500) {
          this.regionDownSearchWidth = this.screenWidth - 512
        }
        const poper = document.querySelector('.my-autocomplete')
        if (poper) {
          poper.style.width = this.regionDownSearchWidth + 'px'
        }
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    searchAgreementChange (val) {
      if (val) {
        sessionStorage.setItem('searchAgreementChange', 1)
      } else {
        sessionStorage.removeItem('searchAgreementChange')
      }
    },
    handleResize () {
      this.screenWidth = document.body.clientWidth
      if (this.screenWidth <= 1500) {
        this.screenWidth = 1500
      }
      this.regionSearchWidth = this.screenWidth - 1050
      this.regionDownSearchWidth = this.regionSearchWidth
      if (this.screenWidth <= 1600 && this.screenWidth > 1500) {
        this.regionDownSearchWidth = this.screenWidth - 512
      }
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      var typeLan = ''
      if (['value'].includes(type)) {
        var valueHtml = ''
        if (data['type'] !== 'location') {
          if (getLanguage === 'zh') {
            valueHtml = data[type + '_zh'] + ' (' + data[type + '_en'] + ')'
          } else {
            typeLan = type + '_' + getLanguage
            valueHtml = data[typeLan]
          }
        } else {
          typeLan = type + '_' + getLanguage
          valueHtml = data[typeLan]
        }

        return valueHtml
      } else if (['address'].includes(type)) {
        typeLan = type + '_' + getLanguage
        return data[typeLan]
      }
    },
    parentFocus: function () {
      this.$refs['saveDateInput'].focus()
    },
    roomAdd () {
      this.roomNum = parseInt(this.roomNum)
      if (this.roomNum < 8) {
        this.roomNum = this.roomNum + 1
        this.roomLessDo = true
        this.roomInfo = this.roomNum
        if (this.roomNum > this.adultNum) {
          this.adultNum = this.roomNum
          this.adultLessDo = true
          this.adultInfo = this.adultNum
        }
      } else {
        this.roomAddNoDo = true
      }
      this.personInfo = this.adultInfo
      this.allPersonNum = this.adultNum + this.childNum
    },
    roomLess () {
      this.roomNum = parseInt(this.roomNum)
      if (this.roomNum > 1) {
        this.roomNum -= 1
        if (this.roomNum === 1) {
          this.roomLessDo = false
        }
        this.roomInfo = this.roomNum
      }
      if (this.roomNum < 8) {
        this.roomAddNoDo = false
      }
    },
    adultAdd () {
      this.adultNum = parseInt(this.adultNum)
      this.adultNum += 1
      this.adultLessDo = true
      this.adultInfo = this.adultNum
      this.personInfo = this.adultInfo
      this.allPersonNum = this.adultNum + this.childNum
    },
    adultLess () {
      this.adultNum = parseInt(this.adultNum)
      if (this.adultNum > 1) {
        this.adultNum -= 1
        if (this.adultNum === 1) {
          this.adultLessDo = false
        }
        this.adultInfo = this.adultNum
        if (this.roomNum > this.adultNum) {
          this.roomNum = this.adultNum
          this.roomInfo = this.roomNum
          if (this.roomNum === 1) {
            this.roomLessDo = false
          }
          if (this.roomNum < 8) {
            this.roomAddNoDo = false
          }
        }
      }
      this.personInfo = this.adultInfo
      this.allPersonNum = this.adultNum + this.childNum
    },
    childAdd () {
      this.childNum = parseInt(this.childNum)
      if (this.childNum < 10) {
        this.childNum += 1
        this.childLessDo = true
        this.childInfo = ',' + this.childNum
        this.personInfo = this.adultInfo
      } else {
        this.childAddNoDo = true
      }
      if (this.childNum === 1) {
        this.showChildInfo = true
      }
      this.selecteds[this.childNum - 1] = '<1'
      this.allPersonNum = this.adultNum + this.childNum
    },
    childLess () {
      this.childNum = parseInt(this.childNum)
      if (this.childNum > 0 && this.childNum !== '' && this.childNum !== undefined) {
        if (this.selecteds.length === this.childNum) {
          this.selecteds.pop()
        }
        this.childNum -= 1
        this.childInfo = this.childNum
        if (this.childNum === 0) {
          this.childLessDo = false
          this.childInfo = ''
        }
      }
      if (this.roomNum < 8) {
        this.childAddNoDo = false
      }
      if (this.childNum === 0) {
        this.showChildInfo = false
      }
      this.personInfo = this.adultInfo
      this.allPersonNum = this.adultNum + this.childNum
    },
    showPerson () {
      if (this.showPersonInfo === false) {
        this.showPersonInfo = true
      } else {
        this.showPersonInfo = false
      }
    },
    querySearch (queryString, cb) {
      this.state = queryString
      this.triggerOnFocus = true
      var keywordSearch = sessionStorage.getItem('keywordSearch')
      window.queryCallback = cb
      this.loadAll(queryString, 2)
      // let restaurants = this.restaurants
      // let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants

      // 调用 callback 返回建议列表的数据
      if (queryString === '') {
        let restaurants = this.restaurants
        cb(restaurants)
        return false
      }

      // 内容无变化 不请求接口
      if (queryString !== '' && queryString === keywordSearch) {
        let restaurants = this.restaurants
        cb(restaurants)
        return false
      }

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let restaurants = this.restaurants
        cb(restaurants)
        console.log('展示下拉4')
      }, 510)
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
      }
    },
    handleSelect (item) {
      this.region_select = item.type_data_id
      this.region_type = item.type_id
      this.state = item.value_en
      // 保留选择的目的地
      sessionStorage.setItem('regionSel', JSON.stringify(item))

      this.triggerOnFocus = false
      // 选择后，日期是否需要打开昨日房
      let date1 = new Date(this.start_date)
      let date2 = new Date(item.zDateTime)
      if (date1.getTime() < date2.getTime()) {
        // 选择后，日期是否需要打开昨日房
        this.addrDateTime = item.zDateTime
      } else {
        var addrTime = item.zDateTime + ' 00:00:00'
        this.pickerOptions = {
          disabledDate (date) {
            return date.getTime() < new Date(addrTime).getTime()
          }
        }
      }
    },
    loadAll: function (keyword, type) {
      this.state = keyword
      this.frameRegionMustDialog = false
      var keywordSearch = sessionStorage.getItem('keywordSearch')

      // 搜索为空不请求接口
      if (type === 2 && keyword === '') {
        let restaurants = localStorage.getItem('restaurants')
        this.restaurants = JSON.parse(restaurants)
        return false
      }
      // 内容无变化 不请求接口
      if (keyword !== '' && keyword === keywordSearch) {
        let restaurants = localStorage.getItem('restaurants')
        this.restaurants = JSON.parse(restaurants)
        return false
      }

      if (keyword === undefined) {
        keyword = ''
      }

      sessionStorage.setItem('keywordSearch', keyword)
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {'keyword': keyword, 'operation': 'getDestinationList', 'language': this.common.languageSet(this), 'time': time, 'page': 7}
      var data = this.common.encryptionData(dataJson, this)
      getHotelList(data).then(res => {
        if (res.flag === '200') {
          this.restaurants = res.data
          localStorage.setItem('restaurants', JSON.stringify(this.restaurants))

          if (window.queryCallback && this.triggerOnFocus) {
            window.queryCallback(res.data)
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    closepopEven: function (type) {
      if (type === 'hotelSearchFrame') {
        this.hotelSearchFrame = false
      }
    },
    selectTime (val) {
      this.start_date = val[0]
      this.end_date = val[1]
    },
    defaultDate () {
      // 获取酒店列表搜索的 城市/酒店所在城市 的timezone
      var path = this.$route.path
      if (path.indexOf('HotelList') !== -1) {
        var startdate = this.$route.query.start_date
        var enddate = this.$route.query.end_date
        var requestTime = parseInt(new Date().getTime())
        var time = parseInt(requestTime / 1000)
        var dataJson = {'region_type': this.region_type, 'region': this.region_select, 'time': time}
        var data = this.common.encryptionData(dataJson, this)
        getTimeZone(data).then(res => {
          if (res.flag === '200') {
            var startnew = res.data
            const newdate = new Date(startnew)
            newdate.setDate(newdate.getDate() + 1)
            const endnew = newdate.toISOString().split('T')[0]
            if (startdate !== undefined && enddate !== undefined) {
              var resultStart = startdate
              var resultEnd = enddate
              if (startdate < startnew || enddate < endnew) {
                resultStart = startnew
                resultEnd = endnew
              }
              this.start_date = resultStart
              this.end_date = resultEnd
              this.input_date = [resultStart, resultEnd]
            } else {
              this.start_date = startnew
              this.end_date = endnew
              this.input_date = [this.start_date, this.end_date]
            }
            if (this.start_date !== startdate || this.end_date !== enddate) {
              var query = JSON.parse(JSON.stringify(this.$route.query))
              query.start_date = this.start_date
              query.end_date = this.end_date
              this.$router.push({path: '/portal/booking/hotelsearch/HotelList', query: query})
            }
            var dateInfo = {'start_date': this.start_date, 'end_date': this.end_date}
            this.$emit('getSearchDate', dateInfo)
          }
        })
      } else {
        // 详情页-正常进入详情页只有点击进入, 避免影响报价, 走原始逻辑
        let start = this.$route.query.start_date
        let end = this.$route.query.end_date

        // 年月日
        var date1 = new Date()
        date1.setDate(date1.getDate() - 1)
        var date2 = new Date(date1)
        date2.setDate(date1.getDate() + 1)

        var startDateMonth = ((date1.getMonth() + 1) < 10) ? '0' + (date1.getMonth() + 1) : (date1.getMonth() + 1)
        var endDateMonth = ((date2.getMonth() + 1) < 10) ? '0' + (date2.getMonth() + 1) : (date2.getMonth() + 1)

        var startDateDay = (date1.getDate() < 10) ? '0' + date1.getDate() : date1.getDate()
        var endDateDay = (date2.getDate() < 10) ? '0' + date2.getDate() : date2.getDate()
        var startnew = (date1.getFullYear()) + '-' + startDateMonth + '-' + startDateDay
        var endnew = (date2.getFullYear()) + '-' + endDateMonth + '-' + endDateDay
        if ((start !== undefined && start !== null && start !== '' && start !== 'NAN-NAN-NAN') && (end !== undefined && end !== null && end !== '' && end !== 'NAN-NAN-NAN')) {
          this.input_date = [start, end]
        } else {
          start = startnew
          end = endnew
          this.input_date = [start, end]
        }
        this.start_date = start
        this.end_date = end
      }
    },
    getSearchCond (e) {
      this.roomNum = e['room']
      var regionselect = e['region']
      this.region_select = e['type_id']
      if (regionselect !== undefined && regionselect !== null && regionselect !== '') {
        this.state = regionselect
      }
      // 开始时间
      var startdate = e['start_date']
      // 结束时间
      var enddate = e['end_date']
      if ((startdate !== undefined && startdate !== null) && (enddate !== undefined && enddate !== null)) {
        var startmonth = new Date(startdate).getMonth() + 1
        var startday = new Date(startdate).getDate()
        var endmonth = new Date(enddate).getMonth() + 1
        var endday = new Date(enddate).getDate()
        if (this.common.languageSet() === 'zh') {
          this.search_date = startmonth + '月' + startday + '日 - ' + endmonth + '月' + endday + '日'
        } else {
          this.search_date = startday + ' ' + this.common.monthEn[(startmonth - 1)] + ' - ' + endday + ' ' + this.common.monthEn[(endmonth - 1)]
        }
        localStorage.setItem('searchdate', this.search_date)
      }

      if (startdate === enddate) {
        var endDate = new Date(startdate)
        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        enddate = (endDate.getFullYear()) + '-' + endDateMonth + '-' + (endDate.getDate() + 1)
      }

      var room = e['room']
      var adult = e['adult']
      var child = e['child']
      var childnums = e['childNums']
      var typeid = e['type_id']
      var type = e['type']
      var isPkg = 0
      if (this.agreementChecked) {
        isPkg = 1
      }
      var submitInfo = {'region': this.state, 'type_id': typeid, 'type': type, 'start_date': startdate, 'end_date': enddate, 'room': room, 'adult': adult, 'child': child, 'allPersonNum': this.allPersonNum, 'childNums': childnums, 'is_pkg': isPkg}
      this.$emit('getSearchInfo', submitInfo)
      this.allPersonNum = e['allPersonNum']
    },
    searchList () {
      this.showPersonInfo = false
      var typeid = this.region_select
      var type = this.region_type

      // 如果客人输入搜索但无选择 则 搜索默认第一个
      var restaurants = localStorage.getItem('restaurants')
      var restaurantsArr = JSON.parse(restaurants)
      var regionSel = {}
      let newState = this.state
      if (this.triggerOnFocus && restaurants !== null && restaurantsArr.length > 0 && restaurantsArr[0] && restaurantsArr[0].value_en) {
        // 目的地展示文字
        let valueEn = restaurantsArr['0'].value_en.replace(/[^a-zA-Z ]/g, ' ')
        newState = this.state.replace(/[^a-zA-Z ]/g, ' ')
        if (valueEn.toLowerCase().includes(newState.toLowerCase())) {
          typeid = restaurantsArr[0].type_data_id
          type = restaurantsArr[0].type_id
          this.state = restaurantsArr['0'].value_en
          regionSel = {'value_zh': restaurantsArr['0'].value_zh, 'value_en': restaurantsArr['0'].value_en, 'type_id': restaurantsArr['0'].type_id, 'type_data_id': restaurantsArr['0'].type_data_id}
          sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
        } else {
          var regionSelJson = sessionStorage.getItem('regionSel')
          var regionSelArr = {}
          if (regionSelJson === null) {
            regionSelArr = {'value_zh': this.common.defaultRegion, 'value_en': this.common.defaultRegion, 'type_id': this.common.defaultRegionType, 'type_data_id': this.common.defaultRegionId}
            // 保留选择的目的地
            sessionStorage.setItem('regionSel', JSON.stringify(regionSelArr))
          } else {
            regionSelArr = JSON.parse(regionSelJson)
          }
          typeid = regionSelArr.type_data_id
          type = regionSelArr.type_id
          this.state = regionSelArr.value_en
        }
      }
      if (this.start_date === this.end_date) {
        var startDate = new Date(this.start_date)
        let startY = startDate.getFullYear()
        let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)

        var endDate = new Date(this.end_date)
        var endDateStr = startDate.getDate() + 1

        var newStartM = Number(startM) + 1
        var newStartY = startY
        if (newStartM > 12) {
          newStartM = 1
          newStartY = Number(startY) + 1
        }

        var nextMonthFirstDay = new Date(newStartY, Number(newStartM) - 1, 1)
        var lastDayOfMonth = new Date(nextMonthFirstDay - 1)
        var endMaxDate = lastDayOfMonth.getDate()

        if (endDateStr <= endMaxDate) {
          endDate.setDate(endDateStr)
        } else {
          endDate = new Date(newStartY, Number(newStartM) - 1, 1)
        }

        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        var endDateD = (endDate.getDate() < 10) ? '0' + endDate.getDate() : endDate.getDate()
        this.end_date = (endDate.getFullYear()) + '-' + endDateMonth + '-' + endDateD
      }
      var isPkg = 0
      if (this.agreementChecked) {
        isPkg = 1
      }

      var submitInfo = {'region': this.state, 'type_id': typeid, 'type': type, 'start_date': this.start_date, 'end_date': this.end_date, 'room': this.roomNum, 'adult': this.adultNum, 'child': this.childNum, 'allPersonNum': this.allPersonNum, 'childNums': this.selecteds, 'nationality': this.nationality, 'is_pkg': isPkg}

      localStorage.setItem('searchData', JSON.stringify(submitInfo))

      // 点击 列表/详情页 搜索埋点记录
      var searchButtonData = {
        'checkin_date': submitInfo['start_date'],
        'checkout_date': submitInfo['end_date'],
        'rooms': submitInfo['room'],
        'adults': submitInfo['adult'],
        'childs': submitInfo['child'],
        'babys': submitInfo['childNums'],
        'region': submitInfo['region'],
        'nationality': submitInfo['nationality']
      }

      this.clickPageAction('search_button', '', searchButtonData)
      this.$emit('getSearchInfo', submitInfo)
      // var path = this.$route.path
    },
    // 日历弹框
    dateSearchShow: function () {
      // this.$refs.saveDateInput.$el.click()

      var that = this
      this.$refs.saveDateInput.$el.click(function (e) {
        this.$emit('pick', that.input_date)
      })

      if (this.hotelDateSearchShow === false) {
        this.hotelDateSearchShow = true
      }
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'person-pc') {
        if (this.showPersonInfo === true) {
          this.showPersonInfo = false
        }
      }
      if (node.target.getAttribute('data-index') !== 'date-pc') {
        if (this.hotelDateSearchShow === true) {
          this.hotelDateSearchShow = false
        }
      }
    },
    regionSelShow: function () {
      // 搜索框中 中英文转换
      var regionSelJson = sessionStorage.getItem('regionSel')
      var regionSelArr = JSON.parse(regionSelJson)
      if (regionSelArr !== null) {
        if (this.common.languageSet() === 'en') {
          this.state = regionSelArr.value_en
        } else {
          this.state = regionSelArr.value_zh
        }
      }
    },
    mobileSearchShow: function () {
      this.hotelSearchFrame = true
      // 解决组件中下拉按钮屏幕闪动问题
      setTimeout(() => {
        window.scrollTo({
          top: 9999999999999,
          behavior: 'instant'
        })
      }, 1000)
    },
    updateChildSelect: function (num, e) {
      // this.selecteds[num] = e
      this.selecteds.splice(num, 1, e)
      this.$forceUpdate()
    },
    getNationalityAll () {
      var nationalityInfo = sessionStorage.getItem('nationalityMap')
      var nationalityMap = JSON.parse(nationalityInfo)
      if (nationalityMap === undefined || nationalityMap === '' || nationalityMap === '{}' || nationalityMap === null) {
        var requestTime = parseInt(new Date().getTime())
        var time = parseInt(requestTime / 1000)
        var dataJson = {'time': time}
        var data = this.common.encryptionData(dataJson, this)
        getCountry(data).then(res => {
          if (res.flag === '200') {
            nationalityMap = res.data
            this.nationalityAll = nationalityMap
            sessionStorage.setItem('nationalityMap', JSON.stringify(nationalityMap))
          }
        })
      } else {
        this.nationalityAll = nationalityMap
      }
      var queryNationality = this.$route.query.nationality
      if (queryNationality !== '' && queryNationality !== undefined && queryNationality !== null) {
        var code = Object.keys(this.nationalityAll)
        var codeRes = code.includes(queryNationality)
        if (codeRes === true) {
          this.nationality = queryNationality
        } else {
          this.nationality = ''
        }
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth <= 1500) {
      this.screenWidth = 1500
    }
    this.regionSearchWidth = this.screenWidth - 1050
    // 获取数据
    var path = this.$route.path

    var params = this.$route.query
    var searchData = '{}'
    if (path.indexOf('HotelDetail') === -1) {
      searchData = localStorage.getItem('searchData')
    }
    if (JSON.stringify(params) === '{}' && (searchData !== '{}' && searchData !== null && searchData !== 'null')) {
      params = JSON.parse(searchData)
      this.restaurants = this.loadAll(params.region, 1)

      this.state = params.region
      this.region_select = params.type_id
      this.region_type = params.type
      this.roomNum = parseInt(params.room)
      this.roomInfo = parseInt(params.room)
      this.adultNum = parseInt(params.adult)
      this.personInfo = parseInt(params.adult)
      this.adultInfo = parseInt(params.adult)
      this.childNum = parseInt(params.child)
      this.childInfo = parseInt(params.child)
      if (this.childNum !== undefined && this.childNum !== null && this.childNum !== '' && this.childNum > 0 && !isNaN(this.childNum)) {
        this.showChildInfo = true
        this.selecteds = []
        this.selecteds = params.childNums
      }
    } else {
      this.loadAll(this.$route.query.region, 1)
      var regionselect = this.$route.query.region
      if (regionselect !== undefined && regionselect !== null && regionselect !== '') {
        this.state = regionselect
      }

      this.region_select = this.$route.query.type_id
      this.region_type = this.$route.query.type
      var adult = parseInt(this.$route.query.adult)
      var child = parseInt(this.$route.query.child)
      var room = parseInt(this.$route.query.room)
      if (adult !== undefined && adult !== null && adult !== '' && !isNaN(adult)) {
        this.adultNum = adult
        this.personInfo = adult
        this.adultInfo = adult
      }
      if (room !== undefined && room !== null && room !== '' && !isNaN(room)) {
        this.roomNum = room
        this.roomInfo = room
      }
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        // searchData = localStorage.getItem('searchData')
        // var searchDataArr = JSON.parse(searchData)

        this.childNum = child
        this.childInfo = child
        this.showChildInfo = true
        this.selecteds = []
        // this.selecteds = searchDataArr.childNums
        if (typeof this.$route.query.childNums === 'string') {
          this.selecteds.push(this.$route.query.childNums)
        } else {
          this.selecteds = this.$route.query.childNums
        }
      }

      if (this.$route.path.indexOf('HotelDetail') !== -1) {
        this.region_select = this.$route.query.hotelid
        this.region_type = 3
      }
    }
    if (this.selecteds === undefined) {
      this.selecteds = []
    }

    this.allPersonNum = parseInt(this.adultNum) + parseInt(this.childNum)
    var date1 = new Date()
    var date2 = new Date(date1)
    date1.setDate(date1.getDate())
    date2.setDate(date1.getDate() + 1)
    var startmonth = ''
    var startday = ''
    var endmonth = ''
    var endday = ''

    if ((this.start_date !== undefined && this.start_date !== null && this.start_date !== 'NAN-NAN-NAN') && (this.end_date !== undefined && this.end_date !== null && this.end_date !== 'NAN-NAN-NAN')) {
      startmonth = new Date(this.start_date.replace(/-/g, '/')).getMonth() + 1
      startday = new Date(this.start_date.replace(/-/g, '/')).getDate()
      endmonth = new Date(this.end_date.replace(/-/g, '/')).getMonth() + 1
      endday = new Date(this.end_date.replace(/-/g, '/')).getDate()
    } else {
      startmonth = date1.getMonth() + 1
      startday = date1.getDate()
      endmonth = date2.getMonth() + 1
      endday = date2.getDate()
    }
    if (this.common.languageSet() === 'zh') {
      this.search_date = startmonth + '月' + startday + '日 - ' + endmonth + '月' + endday + '日'
    } else {
      this.search_date = startday + ' ' + this.common.monthEn[(startmonth - 1)] + ' - ' + endday + ' ' + this.common.monthEn[(endmonth - 1)]
    }
    localStorage.setItem('searchdate', this.search_date)
    // if (window.performance.navigation.type === 1) {
    // 目的地搜索框中的中英文转换
    // this.regionSelShow()
    // }

    // 人数 间数
    if (parseInt(this.roomNum) > 1) {
      this.roomLessDo = true
    }
    if (parseInt(this.adultNum) > 1) {
      this.adultLessDo = true
    }
    if (parseInt(this.childNum) > 1) {
      this.childAddNoDo = true
    }

    // 下拉框关闭
    document.addEventListener('click', this.bodyCloseMenus)
  }
}
</script>

<style scoped>
.search-box{
  margin-bottom:15px;
  width:100%;
}

.checkbox-label-container {
  display: flex;
  align-items: center;
}
/* 搜索条件 开始 */
.list-search{width: 100%;height: 145px;-ms-overflow-x: hidden;overflow-x: hidden;-ms-overflow-y: hidden;overflow-y: hidden;background-color: #FFF; border-radius: 5px;}
.list-search-placeholder{display: none;background-color:#ffffff}
.location-search-pc{padding:0 15px;height:48px;margin: 26px auto 0px;}
/* 目的地 */
/* .input-region{width: 361px; height: 48px;} */
.location-search-pc .hotellist-region /deep/ .el-input__inner{padding: 0 53px;height: 48px; background-image: url(https://res.roompai.com/static/img/input-region.png);background-repeat: no-repeat;background-size: 23px;background-position: 15px center;}
.location-search-pc .hotellist-region{vertical-align: top;float: left;margin-right:5px;}
.el-autocomplete{width:100%;}
/* .el-autocomplete /deep/ .el-input__inner{ font-size: 16px;} */
.location-search-pc .hotellist-region input{background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-region.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
.location-search-pc .hotellist-region /deep/ .el-input__inner:focus,.hotellist-region input:focus{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}

/deep/ .my-autocomplete{position:fixed!important;top:auto!important;left:auto!important;z-index: 1000!important;}
/deep/ .my-autocomplete li{padding:0px;color: #4F4C4C;}
/deep/ .my-autocomplete li:hover{color: rgb(83,146,249);}
.my-autocomplete .name {height:25px;text-overflow: ellipsis;overflow: hidden;font-weight: 650;}
.my-autocomplete .addr {height:25px;font-weight: 100;}
.my-autocomplete .highlighted .addr {color: #ddd;}
.my-autocomplete .locationClass{background: url(https://res.roompai.com/static/img/home/input-region.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
/deep/ .el-autocomplete-suggestion li:hover .locationClass{background: url(https://res.roompai.com/static/img/home/input-region-hover.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
.my-autocomplete .hotelClass{background: url(https://res.roompai.com/static/img/home/hotel.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
/deep/ .el-autocomplete-suggestion li:hover .hotelClass{background: url(https://res.roompai.com/static/img/home/hotel-hover.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
/deep/ .el-popper[x-placement^=bottom] .popper__arrow{left: 56px!important;}
/* 国籍 */
.nationality-pc{float: left; margin-right: 5px; height: 48px; width: 220px; display: inline-block;}
.nationality-pc /deep/ .el-input__inner{height: 48px; line-height: 48px;}
.nationality-select{display: flex;height: 48px; line-height: 48px;}
.nationality-pc /deep/ .el-select-dropdown__wrap{max-height: 246px !important;}
.nationality-pc /deep/ .el-range-editor.is-active{border-color: rgba(83, 102, 163, 1);}
/deep/ .el-select .el-input__inner:focus{border-color: #DCDFE6;}
.nationality-pc /deep/ .el-select .el-input.is-focus .el-input__inner{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
/* 日期 */
.hotellist-date-all{float: left;margin-right:5px;height:100%;width:306px;display:inline-block;vertical-align: top;cursor:pointer;position: relative;}
.hotellist-date{padding: 0px;width: 30%; height: 48px;font-size: 16px;opacity:1;}
.hotellist-date .hotellist-date-start{float:left;width: 37%;height: 100%;/*text-indent: 0.5rem;*/line-height: 27px; font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;  font-weight: 650; font-style: normal; color: #4F4C4C;font-size: 14px;}
.hotellist-date .hotellist-date-start-left{width: 35%;}
.hotellist-date .hotellist-date-start .hotellist-date-start-date{width: 100%;height: 50%;line-height: 28px;}
.hotellist-date .hotellist-date-start .hotellist-date-start-week{width: 100%;height: 50%;font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #999999;line-height: 18px;}
.hotellist-date .hotellist-date-line{float:left;width:6%;height: 50%;line-height: 40px;}
.hotellist-date .hotellist-date-line img{width: 65%;height: 100%;}
.hotellist-date .hotellist-date-end{float:right;width: 38%;height: 100%;/*text-indent: 1rem;*/line-height: 27px; font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;  font-weight: 650; font-style: normal; color: #4F4C4C;font-size: 14px;}
.hotellist-date .hotellist-date-end .hotellist-date-end-date{width: 100%;height: 50%;line-height: 28px;}
.hotellist-date .hotellist-date-end .hotellist-date-end-week{width: 100%;height: 50%;font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #999999;line-height: 18px;}
/deep/ .hotellist-date-all .hotellist-date-time-show{position:fixed!important;top:152px!important;}
/deep/ .hotellist-date-all .hotellist-date-time-top-show{position:fixed!important;top:74px!important;}
/deep/ .hotellist-date-hidden.el-range-editor.el-input__inner{background-color: rgb(0 0 0 / 0%)!important;}
/*.hotellist-date{padding: 0px 50px;width: 30%; height: 48px;font-size: 16px;opacity:1;}*/
.el-range-editor.el-input__inner{display:inline-block;}
.hotellist-date.el-range-editor.el-input__inner{width:100%;}
/*.el-date-editor--daterange.el-input__inner{ width:30%;}*/
.input-date-icon{background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 23px;background-position: 0px center;}
.hotellist-date .el-range__icon{margin-left:0px;}
.hotellist-date-show{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}

/* .el-date-table td.end-date span, .el-date-table td.start-date span{ background-color:rgba(79, 76, 76, 1);}
.el-date-table td.in-range div,.el-date-table td.in-range div{background-color:#DCDFE2;}
.el-date-table td.today span{color:rgba(79, 76, 76, 1);} */

/* 入住人 */
.person-inner{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;line-height: 18px;outline: 0;margin: 0em;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-person.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;opacity:1; cursor: pointer;}
.inphotellistut-person .person-inner:hover{border-color:#1a1813;}
/* .el-select-dropdown{display:none;} */
.personLessno{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png"); border: none; background-color: #fff; float: left;margin: 0 15px;}
.personLessno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png")}
.personLess{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
.personLess:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-less-20x20.png");}
.personnum{position: relative;display: inline-block;width: 100%;line-height: 38px;text-align: center;}
.personAdd{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-20x20.png");border: none; background-color: #fff;float: right;margin: 0 15px;}
.personAdd:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-20x20.png");}
.personAddno{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png");}
.personAddno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png")}
.personnum span{display:inline-block;}
.numtext{border:none;outline:none;width:20px;height:32px;color:#409EFF;font-weight: 400; font-size: 18px;}
/* .personnum input:focus{border:0;outline:none;width:20px;height:32px;} */
.spantext{color:#999999; font-size: 14px;}
.select-person{float: left;margin-right:5px;display:inline-block; width:220px;vertical-align: -webkit-baseline-middle;cursor: pointer;height:48px;}
.showPersonBorder{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
.showPersonBorder:hover{border-color:rgba(83, 102, 163, 1);}
.personText{font-weight: 650; font-size:14px;color: #4F4C4C;display:block;height:50%;line-height:28px;white-space: nowrap;overflow: hidden;}
.roomText{font-size:14px;color: #999999;white-space: nowrap;overflow: hidden;display:block;height:50%;}
.childinfo .el-select-dropdown,.el-select-dropdown{display:block}
.selectOld{width: 40%;float: left;margin-left: 6.5%;margin-top: 3%;}
.personSpan{width: 10px;text-align: left;}
/* 加减成人 */
.personLessno{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png");}
.personLess{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
/* 入住人选择 */
.personInfo{width:220px;border-width: 0px;z-index:20;position: fixed;padding:5px 0px;margin-top: 5px;height: auto;background: inherit;background-color: rgba(255, 255, 255, 1);border: none;border-radius: 4px;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451);-webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); color: #999999;font-size: 14px;}
/* 搜索 */
.hotellist_button{cursor: pointer; width:160px !important;height:48px !important;font-size:16px !important;vertical-align: top;}
/* 搜索条件 结束 */
/deep/ .el-popper[x-placement^=bottom]{margin-top: 5px;}
/deep/ .el-popper[x-placement^=top]{margin-bottom: 0px;}
/*搜索栏协议*/
/deep/ .el-checkbox{
}
@media only screen and (max-width:1500px){
  .hotellist-date-all /deep/ .el-popper[x-placement^=bottom]{left: 474px !important;}
  .hotellist-region /deep/ .el-popper[x-placement^=bottom]{min-width: 686px;}
}

</style>



// WEBPACK FOOTER //
// src/components/public/publicSearchCond.vue